// Deployment feature flags, served by GET /api/config (public, pre-auth).
// Fetched once per page load and cached at module level; every consumer after
// the first render shares one request. Defaults are the SAFE state (features
// hidden), so a slow or failed fetch can never flash a disabled feature on.
import { useEffect, useState } from 'react';
import api from './api';

const DEFAULTS = { aiProductionEnabled: false };

let cached  = null;
let promise = null;

export function fetchAppConfig() {
  if (cached) return Promise.resolve(cached);
  if (!promise) {
    promise = api.get('/api/config')
      .then(r => { cached = { ...DEFAULTS, ...r.data }; return cached; })
      .catch(() => DEFAULTS);
  }
  return promise;
}

// `loaded`: the request has settled (HD-11.1: the "Page not found" route waits for it before ruling on a flagged path).
export function useAppConfig() {
  const [config, setConfig] = useState(cached || DEFAULTS);
  const [loaded, setLoaded] = useState(!!cached);
  useEffect(() => {
    let alive = true;
    fetchAppConfig().then(c => { if (alive) { setConfig(c); setLoaded(true); } });
    return () => { alive = false; };
  }, []);
  return { ...config, loaded };
}
